import { Head, useForm } from '@inertiajs/react'
import { Lock, Mail, User } from 'lucide-react'

import { AppShell } from '@/layouts/AppShell'
import { Card } from '@/components/ui/Card'
import { Input } from '@/components/ui/Input'
import { Label } from '@/components/ui/Label'
import { Button } from '@/components/ui/Button'
import { FieldError } from '@/components/feedback/FieldError'

export type TeamRegisterCoachProps = {
  team: {
    id: string
    name: string
  }
}

export default function TeamRegisterCoach({ team }: TeamRegisterCoachProps) {
  const { post, data, setData, processing, errors, transform } = useForm({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
  })

  const submit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    transform((data) => ({ team_coach: data }))
    post(`/team/team_coaches?team_id=${team.id}`)
  }

  return (
    <AppShell>
      <Head title="チームコーチ登録" />
      <div className="mx-auto flex min-h-[70vh] w-full max-w-md flex-col justify-center gap-8 px-4">
        <div className="text-center space-y-3">
          <h1 className="text-3xl font-semibold text-white">{team.name} コーチ登録</h1>
          <p className="text-sm text-white/60">コーチアカウントを作成してダッシュボードにアクセスします。</p>
        </div>
        <Card className="p-6 space-y-6">
          <form className="space-y-4" onSubmit={submit}>
            <div className="space-y-2">
              <Label htmlFor="email" className="flex items-center gap-2 text-white">
                <Mail className="h-4 w-4 text-brand-200" />
                メールアドレス
              </Label>
              <Input
                id="email"
                type="email"
                value={data.email}
                onChange={(event) => setData('email', event.target.value)}
                placeholder="coach@team.jp"
                required
              />
              <FieldError message={errors.email} />
            </div>
            <div className="space-y-2">
              <Label htmlFor="name" className="flex items-center gap-2 text-white">
                <User className="h-4 w-4 text-brand-200" />
                氏名
              </Label>
              <Input
                id="name"
                value={data.name}
                onChange={(event) => setData('name', event.target.value)}
                placeholder="山田 太郎"
                required
              />
              <FieldError message={errors.name} />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="flex items-center gap-2 text-white">
                <Lock className="h-4 w-4 text-brand-200" />
                パスワード
              </Label>
              <Input
                id="password"
                type="password"
                value={data.password}
                onChange={(event) => setData('password', event.target.value)}
                required
              />
              <FieldError message={errors.password} />
            </div>
            <div className="space-y-2">
              <Label htmlFor="passwordConfirmation" className="flex items-center gap-2 text-white">
                <Lock className="h-4 w-4 text-brand-200" />
                パスワード（確認）
              </Label>
              <Input
                id="passwordConfirmation"
                type="password"
                value={data.password_confirmation}
                onChange={(event) => setData('password_confirmation', event.target.value)}
                required
              />
              <FieldError message={errors.password_confirmation} />
            </div>
            <Button type="submit" className="w-full" loading={processing}>
              コーチを登録
            </Button>
          </form>
        </Card>
      </div>
    </AppShell>
  )
}
